<template>
  <div class="leave-index" >
      <!-- <myBreadCrumb :urls="JSON.stringify(breadcrumbs)" @createForm="dialog.state=true" :icon="icon"></myBreadCrumb> -->
      <create-dialog v-model="dialog" @CloseDialog="closeHandler" @fetchData="fetchData"></create-dialog>
      <v-card>
          <v-card-title>
              <v-text-field outlined hide-details 
              placeholder="Nhập Mã NS, tên NS,... để tìm kiếm" 
              v-model="globalSearch" label="Tìm kiếm" persistent-placeholder
              style="max-width: 300px;"
              ></v-text-field>
              <!-- <v-checkbox label="Chuyển vùng" v-model="changeArea" @change="fetchData" class="mx-2"></v-checkbox> -->

              <v-spacer></v-spacer>
              <!-- approve deny button -->
              <v-sheet levation="0" class="rounded-lg pa-2" color="grey lighten-2">
                  <v-btn color="error" @click="deleteHandler"  v-if="selected.length > 0" class="mr-2">Thu hồi </v-btn>

                  <v-btn color="primary" @click="openCreateHandler">Tạo phiếu</v-btn>

              </v-sheet>



              <!-- table controll buttons -->
              <v-btn color="teal" @click="fetchData" icon><v-icon color="teal">mdi-refresh</v-icon></v-btn>
              <v-btn @click="exportExcel" color="teal" icon> <v-icon>mdi-microsoft-excel</v-icon></v-btn>
              <!-- <create-button @click="dialog.state=true" ></create-button> -->
              <v-divider vertical class="mx-2"></v-divider>
              <month-picker width="7rem" v-model="month" label="Chọn tháng" outlined dense></month-picker>
              <!-- <data-filter v-model="params" :filter="filter" @fetchData="fetchData"></data-filter> -->
          </v-card-title>
      </v-card>
      <v-card v-if="true" class="mt-5">
          <v-data-table height="600px"
          :search="globalSearch"
          :mobile-breakpoint="0"
          :headers="headers"
          :items="items"
          single-select
          show-select
          v-model="selected"

          :loading="isLoading"
          loading-text="Đang tải dữ liệu..."
          >
              
              <template v-slot:item.workDate="{ item }">
                  {{ new Date(item.workDate).toLocaleDateString('vi-VN') }}
              </template>
              
              <template v-slot:item.createdAt="{ item }">
                  {{ new Date(item.createdAt).toLocaleDateString('vi-VN') }} - {{ new Date(item.createdAt).toLocaleTimeString('vi-VN') }}
              </template>

              <template v-slot:item.managerName="{ item }">
                    <div :class="item.confirmLevel >= 1 ? 'green--text' : item.isReject ?  'red--text' : ''">
                        {{ item.managerName }} - {{ item.managerCode }}
                        <p>
                            <small :class="item.confirmLevel >= 1 && !item.isReject ? 'green--text' : ''">
                                {{ item.confirmLevel >= 1 ? 'Xác nhận' : '' }}
                            </small>
                            <small :class="item.confirmLevel >= 1  && !item.isReject ? 'red--text' : ''">
                                {{  item.isReject && item.managerCode == item.rejectedByCode ? 'Từ chối' : '' }}
                            </small>
                        </p>
                    </div>
                </template>
                <template v-slot:item.hrAdminName="{ item }">
                    <div :class="item.confirmLevel >= 2? 'green--text' : item.isReject ?  'red--text' : ''">
                        {{ item.hrAdminName }} - {{ item.hrAdminCode }}
                        <p>
                            <small :class="item.confirmLevel >= 2 && !item.isReject ? 'green--text' : '' ">
                                {{ item.confirmLevel >= 2  ? 'Xác nhận' : '' }}
                            </small>
                            <small :class="item.confirmLevel >= 2  && !item.isReject ? 'red--text' : ''">
                                {{  item.isReject && item.hrAdminCode == item.rejectedByCode ? 'Từ chối' : '' }}
                            </small>
                        </p>
                    </div>
                </template>
                <template v-slot:item.hrManagerName="{ item }">
                    <div :class="item.confirmLevel >= 3 ? 'green--text' : item.isReject ?  'red--text' : ''">
                        {{ item.hrManagerName }} - {{ item.hrManagerCode }}
                        <p>
                            <small :class="item.confirmLevel >= 3 && !item.isReject ? 'green--text' : ''">
                                {{ item.confirmLevel >= 3 ? 'Xác nhận' : '' }}
                            </small>
                            
                            <small :class="item.confirmLevel >= 3 && item.isReject ? 'red--text' : ''">
                                {{ item.isReject && item.hrManagerCode == item.rejectedByCode ? 'Từ chối' : '' }}
                            </small>
                        </p>
                    </div>
                </template>
              
              <template v-slot:item.imageUrl="{ item }">
                  <v-img :src="item.imageUrl" max-width="50" @click="viewUrl = item.imageUrl"></v-img>
              </template>
              
              <template v-slot:item.confirmLevel="{ item }">
                  <div v-if="item.isReject" :class="item.isReject ? 'red--text' : ''">Từ chối</div>
                  <div v-if="item.confirmLevel == 0 && !item.isReject">Tạo mới</div>
                  <div v-if="item.confirmLevel == 1 && !item.isReject">Quản lý đã duyệt</div>
                  <div v-if="item.confirmLevel == 2 && !item.isReject">HR đã duyệt</div>
                  <div v-if="item.confirmLevel == 3 && !item.isReject" :class="item.confirmLevel ==3 ? 'green--text' : ''">Hoàn tất</div>
              </template>
          </v-data-table>
      </v-card>
      <!-- ************** DELETE CONFIRMATION *************** -->
      <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
              <v-card-title class="headline">Bạn có chắc muốn xoá dữ liệu này?</v-card-title>
              <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogDelete=false">Thoát</v-btn>
              <v-btn color="blue darken-1" text @click="cfmDeleteItem">OK</v-btn>
              <v-spacer></v-spacer>
              </v-card-actions>
          </v-card>
      </v-dialog>

      <v-dialog :value="!!viewUrl" persistent fullscreen>
        <v-card dark>
          <v-card-title>
            Xem ảnh
            <v-spacer></v-spacer>
            <v-icon @click="viewUrl=null">mdi-close</v-icon>
          </v-card-title>
          <v-img :src="viewUrl" class="my-auto" style="max-height: calc(100vh - 60px);" contain></v-img>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import * as moment from "moment/moment";
import CreateButton from '@/components/Crud/CreateButton';
import http from '@/components/services/http-common';
import Create from './Create.vue';
import DataFilter from '@/components/DataFilter.vue';
import headers from "./headerPersonal";
import { getPersonal, remove } from "./api"

export default {
  name: 'Leave',
  components: {
      CreateButton,
      "create-dialog": Create,
      "data-filter": DataFilter
  },
  watch: {
      tableParams: {
          handler (val) {
              this.fetchData();
              this.fetchCity();
          },
          deep: true,
      },
      filters: {
          handler (val) {
              this.tableParams.page=1;
              this.fetchData();
          },
          deep: true,
      },
      month: {
          handler(val)
          {
              this.filters.from = moment(val, "YYYY-MM").startOf("month").format("YYYY-MM-DD");
              this.filters.to = moment(val, "YYYY-MM").endOf("month").format("YYYY-MM-DD");
          }
      }
  },

  computed: {
      webAllowed() {
          let user = localStorage.getItem("user");
          let webAllowed = localStorage.getItem("WebAllowed");
          user = JSON.parse(user);
          return webAllowed.includes(user.employeeCode);
      },
      params: function() {
          return {...this.tableParams, ...this.filters}
      }
  },
  data() {
      return {
          ROOT_URL: "EmployeeRotationRequests/",

          //HEADER DATA
          icon:{
              icon: "mdi-plus-thick",
              to: ""
          },

          //filters
          month: moment().format("YYYY-MM"),
          changeArea: false,
          globalSearch:"",
          filters:{
              code:null,
              employeeName:null,
              from: moment().startOf("month").format("YYYY-MM-DD"),
              to: moment().endOf("month").format("YYYY-MM-DD"),
          },
          tableParams: {
              sortBy: [],
              sortDesc: [],
              page: 1,
          },
          selected: [],
          rowCount: 0,

          //TABLE
          headers: headers,

          items: [],
          options: {},
          isLoading: true,

          //DIALOG
          dialog: {
              state: false,
              item: undefined,
          },
          dialogDelete: false,
          targetItem: {},
          viewUrl: "",

      }
  },

  methods: {
      
      colorClass(value) {
          switch (value) {
          case 0: return "primary"
          case 1: return "green darken-3"
          case 2: return "red darken-3"
          default: return ""
          }
      },
      formatDate(value) {
          return moment(value).format("DD/MM/YYYY");
      },
      
      status(value) {
          let result = {};
          switch(value) {
              case 0: {
                  result.text = "Chờ duyệt";
                  result.color = "warning"
                  break;
              }
              case 1: {
                  result.text = "Đã duyệt"
                  result.color = "success"
                  break;
              }
              case 2: {
                  result.text = "Từ chối"
                  result.color = "error"
                  break;
              }
              default:{
                  result.text = "unknown"
                  break;
              }
          }
          return result;
      },

      //DATA JS
      fetchData () {
          getPersonal(this.month)
          .then(res => {
              this.items = res.data.data;
              // this.rowCount = res.data;
              this.isLoading = false;
          })
      },
      exportExcel(){
          return http.get(this.ROOT_URL+"hr/export", {
              params: {
                  month: moment(this.month).format('YYYY-MM-DD')
              },
              responseType: 'blob',
          }).then(res => {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', `DANH SACH_PHIEU_HT_${moment(this.month, 'yyyy-MM-dd').format("MM-YYYY")}.xlsx`);
              document.body.appendChild(link);
              link.click();
          });
      },

      changeItemStatus(id, status){
          return http.get(`${this.ROOT_URL}hr/change-status`, {
              params: {
                  id: id,
                  status: status
              }
          })
          .catch(()=> {this.fetchData()})
      },

      //DIALOG METHOD
      openDialog() {
          this.params = {
          }
      },
      closeHandler () {
          this.dialog = {state: false, item: undefined}
      },
      editItem (item) {
          this.dialog = {state: true, item: item}
      },
      deleteItem (item) {
          this.dialogDelete = true;
          this.targetItem = item;
      },
      cfmDeleteItem() {
          http.delete(this.ROOT_URL + "undo/" +this.targetItem.id).then(res => {
              this.fetchData();
              this.dialogDelete = false;
          }).catch(err => {
              switch (err.response.status)
              {
                  case 403:{
                      this.unauthorizeAlert();
                      this.dialogDelete = false;
                      break;
                  }
                  default:
                      break;
              }
          })
      },

      deleteHandler() {
          remove(this.selected).then(r => {
              console.log(r)
              this.fetchData()
          })
      },

      openCreateHandler() {
        this.dialog = {...this.dialog, state: true }
      }

  },
  
  created() {
      this.fetchData();
  }
}
</script>